import { useEffect, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import api from "@/lib/api";
import { Loader, fmtDateTime, EmptyState } from "@/components/shared";

export default function Notifications() {
  const [data, setData] = useState(null);
  const load = async () => { const r = await api.get("/notifications"); setData(r.data); };
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); window.dispatchEvent(new Event("notif-refresh")); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); window.dispatchEvent(new Event("notif-refresh")); };

  if (data === null) return <Loader />;
  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div className="flex items-center justify-between">
        <div>
          <p className="label-eyebrow text-xs font-mono uppercase tracking-[0.2em] text-cyan-400">Notifications</p>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white mt-1">Your Notifications</h1>
        </div>
        {data.unread > 0 && (
          <button onClick={markAll} data-testid="notif-mark-all" className="glass glass-hover px-4 py-2 rounded-lg text-sm text-cyan-300 inline-flex items-center gap-2"><CheckCheck className="w-4 h-4" /> Mark all read</button>
        )}
      </div>
      {data.items.length ? (
        <div className="space-y-3">
          {data.items.map((n) => (
            <div key={n.id} onClick={() => !n.read && markOne(n.id)} data-testid={`notif-${n.id}`}
              className={`glass rounded-2xl p-5 flex gap-4 cursor-pointer transition-colors ${!n.read ? "border-cyan-500/30" : "opacity-70"}`}>
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${!n.read ? "bg-cyan-500/15 text-cyan-300" : "bg-slate-700/30 text-slate-500"}`}><Bell className="w-5 h-5" /></div>
              <div className="flex-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="font-medium text-slate-100">{n.title}</p>
                  {!n.read && <span className="w-2 h-2 rounded-full bg-cyan-400 shrink-0" />}
                </div>
                <p className="text-sm text-slate-400 mt-1">{n.message}</p>
                <p className="text-xs text-slate-600 mt-2">{fmtDateTime(n.created_at)}</p>
              </div>
            </div>
          ))}
        </div>
      ) : <EmptyState icon={Bell} title="No notifications" subtitle="You're all caught up." />}
    </div>
  );
}
